import { render, staticRenderFns } from "./FormInputItem.vue?vue&type=template&id=bb7cd8d4&scoped=true&"
import script from "./FormInputItem.vue?vue&type=script&lang=js&"
export * from "./FormInputItem.vue?vue&type=script&lang=js&"
import style0 from "./FormInputItem.vue?vue&type=style&index=0&id=bb7cd8d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7cd8d4",
  null
  
)

export default component.exports